export const chipPadding = 5
export const chipOpacity = 0.4